import { I18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { Link } from "./";

export enum Route {
  Root = "/reports",
  Performance = "/reports/performance",
  Summary = "/reports/summary",
  Generator = "/reports/generate",
  UtilitiesPortfolio = "/reports/performance/utilities",
  UtilitiesType = "/reports/performance/utilities/:type",
  UtilitiesSite = "/reports/performance/utilities/:type/:siteId",
  WorkflowPortfolio = "/reports/performance/workflow",
  WorkflowSite = "/reports/performance/workflow/site/:siteId",
  WorkflowTeam = "/reports/performance/workflow/team/:teamId",
  ComfortPortfolio = "/reports/performance/comfort",
  ComfortZones = "/reports/performance/comfort/:siteId",
  Equipment = "/reports/performance/equipment",
}

export const links: Link[] = [
  {
    label: (i18n: I18n) => i18n._(t("reports.performance")`Performance`),
    href: Route.Performance,
  },
  {
    label: (i18n: I18n) =>
      i18n._(t("reports.monthly_summary")`Monthly Summary`),
    href: Route.Summary,
  },
  {
    label: (i18n: I18n) => i18n._(t("reports.generator")`Generator`),
    href: Route.Generator,
  },
];

export const SecondaryLinks = !process.env.BETA
  ? links.filter((l) => !l.isBeta)
  : links;

export const PerformanceTertiaryLinks: Link[] = [
  {
    label: (i18n: I18n) => i18n._(t("reports.performance_workflow")`Workflow`),
    href: Route.WorkflowPortfolio,
  },
  {
    label: (i18n: I18n) => i18n._(t("reports.performance_comfort")`Comfort`),
    href: Route.ComfortPortfolio,
  },
  {
    label: (i18n: I18n) =>
      i18n._(t("reports.performance_utilities")`Utilities`),
    href: Route.UtilitiesPortfolio,
  },
  // {
  //   label: (i18n: I18n) => i18n._(t('reports.performance_sysequip')`Systems & Equipment`),
  //   href: Route.Equipment
  // }
];
